import React from 'react';
import Flags from 'country-flag-icons/react/3x2';

export default function CountrySelectionSm({switchLang}) {
  return (
    <div className="absolute w-56 bg-white right-7 top-[70px] rounded-xl shadow-xl">
      <span className="drop-reference"></span>
      <ul className="py-2">
        <li className="flex w-full p-1.5 px-7 items-center cursor-pointer" onClick={() => switchLang('Nigeria')}>
          <Flags.NG title="Nigeria" className="w-8 h-8 pr-2" />
          <label className="">Nigeria</label>
        </li>
        <li className="flex w-full p-1.5 px-7 items-center cursor-pointer" onClick={() => switchLang('Ghana')}>
          <Flags.GH title="Ghana" className="w-8 h-8 pr-2" />
          <label className="">Ghana</label>
        </li>
        <li className="flex w-full p-1.5 px-7 items-center cursor-pointer" onClick={() => switchLang('Togo')}>
          <Flags.TG title="Togo" className="w-8 h-8 pr-2" />
          <label className="">Togo</label>
        </li>
      </ul>
    </div>
  )
}
